import { get_resource_uri } from "../util/cache_buster";

const GWT_URL = 'app/app.nocache.js';

const initGWT = () => {
	const script = document.createElement("script");
	script.src = get_resource_uri(GWT_URL);	
	document.documentElement.appendChild(script);
}

export {
	initGWT
}
 